<template>
    <c-row>
        <c-col span="12">
            <c-form @submit.prevent="validateBeforeSubmit">
                <c-form-switch label="Enforce MFA for all users" v-model="settings.is_mfa_required" />
            </c-form>
        </c-col>
        <c-col>
        <nav class="navbar">
          <div class="navbar__start">
          </div>
          <div class="navbar__end">
            <a class="navbar__item" v-tooltip="'Write Changes'" @click="onConfirm"><i class="icon-floppy-disk u-h4 u-color-success"></i><span class="u-color-success u-ml-5">SAVE CHANGES</span></a>
          </div>
        </nav>
        </c-col>
    </c-row>
</template>
<script>
import { mapState } from 'vuex'
import { clients } from '../../services/client.service'

export default {
  name: 'ClientSettings',

  data () {
    return {
      userName: '',
      client: '',
      settings: {
        client_id: null,
        client: null,
        client_name: null,
        retention_period: null,
        is_mfa_required: null
      }
    }
  },
  computed: {
    ...mapState('auth', ['clientCode'])
  },
  created () {
    this.fetchSettings()
  },

  methods: {
    fetchSettings () {
      clients.getClientSettings(this.clientCode).then((response) => {
        this.settings = response.data
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
        this.$snotify.error(
          'Error retrieving data',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          }
        )
      })
    },
    onConfirm () {
      this.validateBeforeSubmit()
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.savePreferences()
        }
      })
    },
    savePreferences () {
      clients.saveClientSettings(this.clientCode, this.settings).then((response) => {
        console.log(response.data)
        this.$snotify.success(
          'Changes saved successfully',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          }
        )
      }).catch((reason) => {
        console.error('Could not save client settings')
        this.globalError = 'Could not save client settings'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientSettings/Settings.vue